import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreDepartment as apiRestore } from "../../api/apiDepartments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreDepartment() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreDepartment, isPending: isRestore } = useMutation({
        mutationFn: (id) => apiRestore(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["departments"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreDepartment, isRestore };
}
